/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { Box, makeStyles, Grid } from '@material-ui/core';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import RoomIcon from '@material-ui/icons/Room';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

// import { Maps } from './Maps';
import OfficeView from '../../../shared/assets/Foto_originale.jpg';
import { Text } from '../../../shared/components/Text';
import { ContainerSection } from '../../../shared/components/ContainerSection';

const useStyle = makeStyles(theme => ({
  infoContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 20,
  },
  containerIcon: {
    width: 40,
    paddingRight: 20,
    fontWeight: 'bold',
  },

  wrapImage: {
    width: '100%',
  },
  image: {
    maxHeight: 400,
  },
  containerAddress: {
    [theme.breakpoints.down('sm')]: {
      margin: '0 10px',
    },
  },
}));

const Info = ({ label, icon }) => {
  const styles = useStyle();
  return (
    <Box className={styles.infoContainer}>
      <Box className={styles.containerIcon}>{icon}</Box>
      <Text variant="h4">{label}</Text>
    </Box>
  );
};
export const Contacts = () => {
  const classes = useStyle();

  return (
    <ContainerSection anchor="contacts" title="Contatti" position="top">
      <Grid container spacing={10} style={{ marginBottom: '50px' }}>
        <Grid item xs={12} lg={6}>
          <Box component="div" className={classes.wrapImage}>
            <img src={OfficeView} alt="Uffici BG" className={classes.image} />
          </Box>
        </Grid>

        <Grid item xs={12} lg={6} className={classes.containerAddress}>
          <a
            href="https://www.google.com/maps/place/Via+S.+Siro,+33,+20149+Milano+MI/@45.4719887,9.1497245,17z/data=!3m1!4b1!4m5!3m4!1s0x4786c16fdb569e65:0x695275746d92aff9!8m2!3d45.4719887!4d9.1519132"
            target="_blank"
            style={{ textDecoration: 'none' }}
          >
            <Text
              variant="h2"
              labelColor="primary"
              style={{ letterSpacing: 0 }}
            >
              <Trans>Titolo</Trans>
            </Text>
            <Info
              label="Via San Siro, 33 - 20149 Milano"
              icon={<RoomIcon color="primary" style={{ fontSize: 20 }} />}
            />
          </a>
          <Info
            label="02 25541900"
            icon={
              <Text variant="h4" labelColor="primary" display="inline">
                T
              </Text>
            }
          />
          <Info
            label="02 25061318"
            icon={
              <Text variant="h4" labelColor="primary" display="inline">
                F
              </Text>
            }
          />
          <a href="mailto:info@bgsp.it " style={{ textDecoration: 'none' }}>
            <Info
              label="info@bgsp.it"
              icon={
                <AlternateEmailIcon color="primary" style={{ fontSize: 20 }} />
              }
            />
          </a>
        </Grid>
      </Grid>
    </ContainerSection>
  );
};

Info.propTypes = {
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.any.isRequired,
};
